import { TextField } from '@mui/material';
import React from 'react'


interface Props {
    inputRef: React.RefObject<HTMLInputElement>;
    textLabel: string
    disabled:boolean
}

const TextFieldComponent = ({ inputRef, textLabel,disabled }: Props) => {
    return (
        <TextField disabled={disabled} inputRef={inputRef} fullWidth size='small' margin="normal" label={textLabel} InputLabelProps={{ shrink: true }} sx={{
            '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
            },
        }} />
    ) 
}

export default TextFieldComponent